import { render } from "./CustomNotification.vue?vue&type=template&id=a49173c0&scoped=true"
import script from "./CustomNotification.vue?vue&type=script&lang=js"
export * from "./CustomNotification.vue?vue&type=script&lang=js"

import "./CustomNotification.vue?vue&type=style&index=0&id=a49173c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a49173c0"]])

export default __exports__